export default "__VITE_ASSET__Q4vJp_uJ__"